/**
 * Конфигурация карты и слоев
 * TODO: Адаптировать из client/src/config.js и client/src/Maps/FullMap.js
 */

// Центр карты по умолчанию (EPSG:3857)
export const DEFAULT_CENTER = [3500000, 8350000];

// Зум по умолчанию
export const DEFAULT_ZOOM = 7;

// Конфигурация постоянных слоев
export const PERMANENT_LAYERS = {
  landspol: {
    name: 'landspol',
    visible: true,
    date: 'current'
  },
  pickuppnt: {
    name: 'pickuppnt',
    visible: true,
    date: 'nodate'
  }
};

// Конфигурация подключаемых слоев
export const OPTIONAL_LAYERS = {
  zonespol: {
    name: 'zonespol',
    visible: true,
    date: 'current'
  },
  zninspol: {
    name: 'zninspol',
    visible: true,
    date: 'current'
  },
  oopt: {
    name: 'oopt',
    visible: true,
    date: 'current'
  },
  admpol: {
    name: 'admpol',
    visible: false,
    date: 'current'
  },
  dtplin: {
    name: 'dtplin',
    visible: false,
    date: 'current'
  },
  dtppnt: {
    name: 'dtppnt',
    visible: false,
    date: 'current'
  }
};

// Порядок слоев (z-index)
export const LAYER_ORDER = {
  'plan': 5,
  'oopt': 5,
  'landspol': 10,
  'setl_eeko': 15,
  'admpol': 20,
  'eapol': 25,
  'features': 28,
  'dispol': 30,
  'routeslin': 31,
  'routes': 31,
  'passagelin': 35,
  'correctlin': 40,
  'pickuppnt': 1200,
  'points': 45,
  'select': 1000,
  'flash': 60,
  'important': 90,
  'goto': 100,
  'measure': 110
};

/**
 * Получение текущей даты в формате для API
 * @returns {string} Дата в формате DD.MM.YYYY
 */
export function getCurrentDate() {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  return `${day}.${month}.${year}`;
}

export default {
  DEFAULT_CENTER,
  DEFAULT_ZOOM,
  PERMANENT_LAYERS,
  OPTIONAL_LAYERS,
  LAYER_ORDER,
  getCurrentDate
};


